module.exports = "<nv-button (onClick)=\"onClick()\" [plus]=\"false\" [btnClass]=\"'btn-info'\">Загрузить спайн анимации</nv-button>\n"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/app/components/nv-spine/nv-spine-button.component.html
// module id = ../../../../../src/app/components/nv-spine/nv-spine-button.component.html
// module chunks = 0